import { AuthGuard } from '../../shared/guards/AuthGuard';
import { ProccessCancelBlockClientPresentation } from './components';
import { Sidebar } from '../../shared/components';

export const ProccessCancelBlockClientPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <ProccessCancelBlockClientPresentation />
            </Sidebar>
        </AuthGuard>
    )
};